<template>
  <v-container>
    <v-progress-circular
      indeterminate
      color="primary"
      v-if="!this.apiErrorMsg"
    ></v-progress-circular>

    <br />

    <v-alert v-if="this.apiErrorMsg" prominent type="error">
      <v-row align="center">
        <v-col class="grow">
          {{ this.apiErrorMsg }}
        </v-col>
        <v-col class="shrink">
          <v-btn @click="closeWindow()">Close Window</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <span v-if="!this.apiErrorMsg">
      <b>
        Please do not close this window, executing job... <br />
        This windows will auto close after completed.
      </b>
    </span>
  </v-container>
</template>

<script>
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcData from "@/services/hrdc_event/objects/globalData";
import { mapState } from "vuex";
import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import moment from "moment";

export default {
  props: ["params"],
  mixins: [hrdcFunction],
  data: () => ({
    model: new Model(),
    service: new Service(),
    apiXeroExchangeCode: new Api(),
    apiStoreXeroToken: new Api(),
    hrdcData: new HrdcData(),
    apiErrorMsg: null,
  }),
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,

    }),
  },
  methods: {
    getRedirectUri() {
      const config = require("@/services/hrdc_event/eventRegistry").getEventConfig(this.service.key);
      const suffix = config ? config.pathSuffix : this.service.key.replace("hrdc_", "");
      return `${process.env.VUE_APP_URL}/en/service/${this.service.key}/callback_xero_${suffix}`;
    },
    closeWindow() {
      window.close();
    },
  },
  created() {
    this.model.getByKey(this.params.modelKey);
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);

    // Events Assignation.
    this.serviceDataAssignation(this.model.serviceKey);

    const apiDetails = {
      apiStoreXeroToken: {
        url: `${this.$service[this.service.key]}/v1/en/console/xero/store-xero-token`,
        method: "post",
      },
      apiXeroExchangeCode: {
        url: `${this.$service[this.service.key]}/v1/en/console/xero/exchange-code`,
        method: "post",
      },
    };

    for (const api in apiDetails) {
      if (apiDetails[api].url !== undefined) {
        this[api].setUrl(apiDetails[api].url);
      }
      if (apiDetails[api].method !== undefined) {
        this[api].setMethod(apiDetails[api].method);
      }
      if (apiDetails[api].params !== undefined) {
        this[api].setParams(apiDetails[api].params);
      }
    }

    // Xero client secret + token URL are applied server-side; the client only
    // sends the authorization code.
    this.apiXeroExchangeCode.setParams({
      grant_type: "authorization_code",
      code: this.$route.query.code,
      redirect_uri: this.getRedirectUri(),
    });
    this.apiXeroExchangeCode.setCallbackCompleted((response) => {
      try {
        if (!response || !response.status) {
          throw new Error("Invalid Response");
        }

        // 1. Store refresh_token in db.
        this.apiStoreXeroToken.setParams({
          valid_from: moment().format("YYYY-MM-DD"),
          valid_to: moment().add(58, "days").format("YYYY-MM-DD"),
          token_type: "refresh_token",
          token: response.data.refresh_token,
          userUuid: this.auth.uuid,
          applicationUuid: this.$route.query.state,
          subscriptionStageId:
            this.hrdcData.stagePriority.subscriptionDateScheduled,
        });
        this.apiStoreXeroToken.setCallbackCompleted(
          async (apiStoreXeroTokenRes) => {
            try {
              if (!apiStoreXeroTokenRes || !apiStoreXeroTokenRes.status) {
                throw new Error("Failed to generate refresh token");
              }

              return window.close();
            } catch (err) {
              console.log(err);
              this.apiErrorMsg = err.message;
              return false;
            }
          }
        );

        this.apiStoreXeroToken.fetch();
      } catch (err) {
        let errorMsg = err.message;
        if (err.response?.data?.error) {
          errorMsg = err.response.data.error;
        }

        this.apiErrorMsg = `
          XERO Error Message: ${errorMsg};
          You can close this windows manually now.
        `;

        return false;
      }
    });
    this.apiXeroExchangeCode.fetch();
  },
};
</script>
